// material ui icons
import { ImageNotSupported as ImageNotSupportedIcon } from '@mui/icons-material';

// material ui
import { Box, Stack, Typography } from '@mui/material';

const ImageDisplay = ({
  imageUrl,
  imageFailed,
  onImageError,
  t,
  alt = 'Image',
}) => {
  if (!imageUrl || imageFailed) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{ py: 4 }}
      >
        <ImageNotSupportedIcon color="disabled" sx={{ fontSize: 48 }} />
        <Typography variant="caption" color="text.secondary">
          {t('common.noImage')}
        </Typography>
      </Stack>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <img
        src={imageUrl}
        style={{
          width: '100%',
          height: '40vh',
          objectFit: 'cover',
          display: 'block',
        }}
        onError={onImageError}
        alt={alt}
      />
    </Box>
  );
};

export default ImageDisplay;
